import AgentLandscape from './AgentLandscape';
function App() { return <AgentLandscape />; }
export default App;
